import VueRouter from 'vue-router';
import router from '../router';

const { isNavigationFailure, NavigationFailureType } = VueRouter;

// Landing on the current route, or being sent elsewhere by a guard (the auth
// guard redirects to Login), are both expected outcomes of a goto, not errors.
const isExpectedFailure = error =>
  isNavigationFailure(error, NavigationFailureType.duplicated) ||
  isNavigationFailure(error, NavigationFailureType.redirected);

const goto = (pageName, options) => {
  let route = { name: pageName };
  if (typeof options === 'object') {
    route = { ...route, ...options };
  }
  console.log('route', route);
  router.push(route).catch(error => {
    if (isExpectedFailure(error)) return;
    throw error;
  });
};

const navigation = {
  setup(namespace, root) {
    const { handlers, shortcuts } = this;
    Object.keys(handlers).forEach(handlerName => {
      root.on(`${namespace}.${handlerName}`, this.handlers[handlerName]);
    });
    // setup shortcuts
    Object.keys(shortcuts).forEach(shortcut => {
      root[shortcut] = shortcuts[shortcut]; // eslint-disable-line
    });
  },
  handlers: {
    goto,
  },
  shortcuts: {
    goto(pageName, options) {
      goto(pageName, options);
    },
  },
};

export default navigation;
